import { InputAdornment } from '@material-ui/core';
import React, { FC, memo } from 'react';
import { WrappedFieldProps } from 'redux-form';

import { Input as SharedInput } from 'src/Input';

import CheckMarkIcon from '../../images/checkmark.svg';
import ErrorIcon from '../../images/error.svg';
import USAIcon from '../../images/usa.svg';
import Caption from '../../Typography/Caption';
import useStyles from './styles';

export interface InputProps extends WrappedFieldProps {
  type: string;
  withAdornment?: boolean;
}

export const Input: FC<InputProps> = props => {
  const classes = useStyles();
  const {
    type,
    input: inputProps,
    meta: { valid, error, touched },
    withAdornment,
    ...otherProps
  } = props;

  // The icons are decorative: "+1" names the prefix, and the error text below
  // the field names the error.
  const renderStartAdornment = () => {
    if (type === 'tel') {
      return (
        <InputAdornment classes={{ root: classes.phoneStartAdornment }} position="start">
          <img alt="" className={classes.phoneIcon} src={USAIcon} />
          <Caption classes={{ root: classes.phoneText }} color="red">
            +1
          </Caption>
        </InputAdornment>
      );
    }
    return null;
  };

  const renderEndAdornment = () => {
    if (withAdornment) {
      if (!valid && touched) {
        return (
          <InputAdornment position="end">
            <img alt="" src={ErrorIcon} />
          </InputAdornment>
        );
      }

      if (valid) {
        return (
          <InputAdornment position="end">
            <img alt="" src={CheckMarkIcon} />
          </InputAdornment>
        );
      }
    }

    return null;
  };

  return (
    <SharedInput
      endAdornment={renderEndAdornment()}
      error={touched && error}
      inputProps={inputProps}
      startAdornment={renderStartAdornment()}
      type={type}
      {...otherProps}
    />
  );
};

export default memo(Input);
